import { StringColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';
import moment from 'moment';

const convertEpochToDateTimeIST = (epochTime: number): string => {
	return moment
		.unix(epochTime / 1000)
		.utcOffset('+05:30')
		.format('DD/MM/YYYY HH:mm:ss');
};

export const COL_NAMES = {
	tournamentId: 'ltid',
	uid: 'uid',
	playingAttempt: 'playingAttempt',
	rank: 'rank',
	kindReward: 'kindReward',
	winningAmount: 'winningAmount',
	winningTime: 'winningTime'
};

export const columnConfigs = [
	StringColumn({
		title: 'Tournament Id',
		mapDataToValue: (data: any) => data[COL_NAMES.tournamentId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'User ID',
		mapDataToValue: (data: any) => data[COL_NAMES.uid] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Product Name',
		mapDataToValue: (data: any) => data[COL_NAMES.kindReward] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Product Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.winningAmount] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Rank',
		mapDataToValue: (data: any) => data[COL_NAMES.rank] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Tournament Time',
		mapDataToValue: (data: any) =>
			data[COL_NAMES.winningTime] ? convertEpochToDateTimeIST(Number(data[COL_NAMES.winningTime])) : EMPTY_STRING
	})
];
